<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <div style="display: none;">
      <div
        id="landmark"
        class="text-center"
      >
        <v-card
          dark
          :style="showPopup"
        >
          <div class="pa-2 text-left">
            <div class="div-overflow-x">
              <div class="d-flex align-center mb-2">
                <span v-if="map.geocoderResponse">
                  <b>{{ map.placeAddress }}</b>
                </span>
                <v-spacer />
                <v-icon
                  color="red"
                  class="ml-2"
                  @click="removeMarkerFromMap()"
                >
                  mdi-close
                </v-icon>
              </div>
              <p class="mb-2">
                <i>
                  {{ $t('Ticketing.latitude') }}: {{ map.coordsLonLat[1] }}
                  <br>
                  {{ $t('Ticketing.longitude') }}: {{ map.coordsLonLat[0] }}
                  <br>
                  <template v-if="map.rasterMarkerRows.length > 0">
                    <span
                      v-for="row in map.rasterMarkerRows"
                      :key="row.label"
                    >
                      {{ $t(row.label) }}: {{ row.value }} {{ formatUdm(row.udm) }}<br>
                    </span>
                  </template>
                  <template v-else>
                    {{ $t(map.rasterMarkerLabel) }}{{ map.rasterMarkerValue }} {{ rasterMarkerUdm }}
                  </template>
                </i>
              </p>

              <raster-layer-table-chart-buttons
                v-if="activeRasterService && (activeRasterService.is_table || activeRasterService.is_graph)"
                :raster-layers="activeRasterService.layers"
                :selected-raster-layer="activeRasterService"
                :is-table="activeRasterService.is_table"
                :is-graph="activeRasterService.is_graph"
                :is-animation="activeRasterService.is_animation"
                :service-name="activeRasterService.service_name"
                :table-chart-range-date="activeRasterService.table_chart_range_date"
                :is-daily-data="activeRasterService.daily_data"
              />
            </div>
          </div>
        </v-card>
        <div
          v-if="map.isCenterMarker"
          v-blur
          class="icon"
          @click="togglePopup()"
        >
          <i />
        </div>
        <v-icon
          v-else
          v-blur
          x-large
          color="black"
          @click="togglePopup()"
        >
          mdi-map-marker
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { displayUdmSymbol } from '@/utils.js';

export default {
  components: {
    RasterLayerTableChartButtons: () => import('@/components/utils/RasterLayerTableChartButtons')
  },
  props: {
  },
  data () {
    return {
      overlay: false
    };
  },
  computed: {
    ...mapState(['map', 'wsServices']),
    showPopup() {
      return this.map.isPopupMarker ? '' : 'display: none';
    },
    activeRasterService() {
      return this.wsServices.activeServices.filter(s => s.service_type === 'RASTER')[0];
    },
    rasterMarkerUdm() {
      return displayUdmSymbol(this.map.rasterMarkerUdm);
    }
  },
  watch: {
    $route() {}
  },
  mounted() {
  },
  methods: {
    ...mapActions(['closePopupOnMap', 'removeMarkerFromMap']),
    formatUdm(udm) {
      return displayUdmSymbol(udm);
    },
    togglePopup() {
      this.map.isPopupMarker = !this.map.isPopupMarker;
      this.map.landmark.panIntoView();
      this.closePopupOnMap();
      this.map.select.getFeatures().clear();
    }
  }
};
</script>

<style scoped>
@-webkit-keyframes anim-glow {
  0% {
    box-shadow: 0 0 #4285F4;
  }
  100% {
    box-shadow: 0 0 10px 15px transparent;
  }
}
@keyframes anim-glow {
  0% {
    box-shadow: 0 0 #4285F4;
  }
  100% {
    box-shadow: 0 0 10px 15px transparent;
  }
}
#landmark > .v-icon {
  text-shadow: 0px 3px 5px #333;
}
.v-card {
  max-width: 450px;
  margin-bottom: 15px;
  /* outline-offset: -5px;
  outline: 3px solid #00A644; */
  opacity: 0.95;
  font-family: 'Open Sans', sans-serif;
}
.v-card::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  opacity: 0.90;
  margin-left: -15px;
  border-width: 15px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}
.div-overflow-y{
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.icon {
  border-radius: 50%;
  border: 2px solid #fff;
  width: 30px;
  height: 30px;
  text-align: center;
  position: absolute;
  left: 50%;
  margin-left: -15px;
  -webkit-animation: anim-glow 2s ease infinite;
          animation: anim-glow 2s ease infinite;
}
.icon i {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: inline-block;
  opacity: 0.90;
  background-color: #4285F4;
}
</style>
